/**
 * @file Frontend module — routes/AppRoutes.tsx.
 */

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "../pages/Landing/LandingPage";
import JoinPage from "../pages/Landing/JoinPage";
import ImpactPage from "../pages/Landing/ImpactPage";
import ResearchPage from "../pages/Landing/ResearchPage";
import AboutPage from "../pages/Landing/AboutPage";
import WhoWeArePage from "../pages/Landing/WhoWeArePage";
import WhatWeDoPage from "../pages/Landing/WhatWeDoPage";
import LeadershipPage from "../pages/Landing/LeadershipPage";
import PartnersPage from "../pages/Landing/PartnersPage";
import ResourceLibraryPage from "../pages/Landing/ResourceLibraryPage";
import EventsPage from "../pages/Landing/EventsPage";
import CookiesPolicyPage from "../pages/Landing/CookiesPolicyPage";
import PrivacyPolicyPage from "../pages/Landing/PrivacyPolicyPage";
import LegalPage from "../pages/Landing/LegalPage";
import TermsOfUsePage from "../pages/Landing/TermsOfUsePage";
import ImprintPage from "../pages/Landing/ImprintPage";
import FAQPage from "../pages/Landing/FAQPage";
import GlossaryPage from "../pages/Landing/GlossaryPage";
import LoginPage from "../pages/Auth/login/LoginPage";
import SignupPage from "../pages/Auth/signup/SignupPage";
import { useAuth } from "../context/AuthContext";
import ProtectedRoute from "../components/Shared/ProtectedRoute";

import ContributorDashboard from "../pages/Dashboard/Contributor/ContributorDashboard";
import UserDashboard from "../pages/Dashboard/User/UserDashboard";
import AdminDashboard from "../pages/Dashboard/Admin/AdminDashboard";
import ExpertDashboard from "../pages/Dashboard/Expert/ExpertDashboard";
import AdminLoginPage from "../pages/Auth/login/AdminLoginPage";
import ExpertLoginPage from "../pages/Auth/login/ExpertLoginPage";
import SubmittedDatasetDetail from "../pages/SubmittedDatasetDetails/SubmittedDatasetDetail";

const AppRoutes = () => {
  const { user } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/join" element={<JoinPage />} />
        <Route path="/impact" element={<ImpactPage />} />
        <Route path="/research" element={<ResearchPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/who-we-are" element={<WhoWeArePage />} />
        <Route path="/what-we-do" element={<WhatWeDoPage />} />
        <Route path="/leadership" element={<LeadershipPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/resource-library" element={<ResourceLibraryPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/cookies-policy" element={<CookiesPolicyPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/legal" element={<LegalPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="/imprint" element={<ImprintPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/glossary" element={<GlossaryPage />} />
        <Route path="/login" element={<LoginPage />} />

        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/expert/login" element={<ExpertLoginPage />} />

        <Route path="/signup" element={<SignupPage />} />

        <Route
          path="/expert"
          element={
            <ProtectedRoute>
              <ExpertDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              {user?.role === "SUPER_ADMIN" ? (
                <AdminDashboard />
              ) : user?.role === "ADMIN" ? (
                <AdminDashboard />
              ) : user?.role === "CONTRIBUTOR" ? (
                <ContributorDashboard />
              ) : user?.role === "EXPERT" ? (
                <ExpertDashboard />
              ) : user?.role === "REVIEWER" ? (
                <ExpertDashboard />
              ) : (
                <UserDashboard />
              )}
            </ProtectedRoute>
          }
        />

        {/* ✅ Dataset Detail Page */}
    <Route
      path="/datasets/:id"
      element={
        <ProtectedRoute>
          <SubmittedDatasetDetail />
        </ProtectedRoute>
      }
    />
  
      </Routes>
    </BrowserRouter>
  );
};

/** React component — App Routes. */
export default AppRoutes;
